import { useMutation } from '@tanstack/react-query'

import { useResyncBuilding } from '@/api/building'
import { authAPI } from '@/api/new-api'
import { composeFormData } from '@/utils'

import { PmsProvider } from './pms.constants'

export interface ConnectPmsRequest {
  buildingId: number
  companyId: number
  propertyId: string | number
  provider: PmsProvider
}

export const connectPms = async ({
  buildingId,
  companyId,
  propertyId,
  provider,
}: ConnectPmsRequest) => {
  await authAPI.put(
    `/building/${buildingId}/integration`,
    composeFormData({
      [`${provider}ManagementId`]: companyId,
      [`${provider}PropertyId`]: propertyId,
    }),
    { headers: { 'content-type': 'multipart/form-data' } },
  )
}

export interface DisconnectPmsRequest {
  buildingId: number
  provider: PmsProvider
}

export const disconnectPms = async ({ buildingId, provider }: DisconnectPmsRequest) => {
  await authAPI.post(`/building/${buildingId}/integration/disconnect`, { pms: provider })
}

// Note: the connected state lives on the Redux building, so it is re-read after every change
export const useConnectPms = () => {
  const resyncBuilding = useResyncBuilding()

  return useMutation({
    mutationFn: connectPms,
    onSuccess: (_, { buildingId }) => resyncBuilding(buildingId),
  })
}

export const useDisconnectPms = () => {
  const resyncBuilding = useResyncBuilding()

  return useMutation({
    mutationFn: disconnectPms,
    onSuccess: (_, { buildingId }) => resyncBuilding(buildingId),
  })
}
